import { getLineGraphFormat, getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
import {
  formatDataByTrend,
  formatDataByEditionEntity,
} from "./format-data-by-trend";
import { formatDataByTonality } from "./format-data-by-tonality";
const { AREA } = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;

export const formatDataByCity = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type,
  selectedEdition,
  editionList
) => {
  const citiesArray = editionList.map(e => (e.edition_name)) || [
    "Hyderabad",
    "Mumbai",
    "New Delhi",
    "Chennai",
    "Kolkata",
    "National",
    "Ahmedabad",
    "Bangalore",
    "International",
  ];
  if (
    report_type === REPORT_TYPES.CityWiseNOATrend ||
    report_type === REPORT_TYPES.CityWiseCCMTrend ||
    report_type === REPORT_TYPES.CityWiseMAVTrend
  ) {
    return formatDataByTrend(d, graph_type, isLineGraph, type, report_type);
  }
  if (report_type === REPORT_TYPES.MediaWiseNOARanking) {
    return formatDataByEditionEntity(
      d,
      graph_type,
      isLineGraph,
      type,
      report_type
    );
  }
  if (
    report_type === REPORT_TYPES.CityWiseTonality ||
    report_type === REPORT_TYPES.StateWiseTonality ||
    report_type === REPORT_TYPES.CityWiseCCMTonality ||
    report_type === REPORT_TYPES.CityWiseMAVTonality
  ) {
    return formatDataByTonality(d, graph_type, isLineGraph, type, report_type);
  }
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const cities =
      selectedEdition && selectedEdition.label
        ? [selectedEdition.label]
        : citiesArray;
    const {
      graphDataType: { print, online },
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    const dataByReportType = d[rType] && d[rType].returnData;
    let labels = dataByReportType && dataByReportType.map((d) => d.entity);
    labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
    const graphColors = getRandomUniqueColor(cities.length);
    const datasets = cities.map((city, index) => {
      let data =
        dataByReportType && dataByReportType.map((entity) => entity[city] || 0);
      data = isLineGraph ? getLineGraphFormat(data) : data;
      return {
        data,
        label: city,
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(graphColors[index]).alpha(0.5).rgbString()
            : graphColors[index],
        borderColor: graphColors[index],
        borderWidth: 1,
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
        minBarLength: 1,
      };
    });
    return {
      datasets,
      labels,
    };
  } catch (e) {
    console.log(e);
    return {
      datasets: [],
      labels: [],
    };
  }
};
